module.exports = __webpack_public_path__ + "img/iconoinfantesdashboard.24b90057.png";